import {Link} from "react-router-dom";
import {Fragment, useContext} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";

export default function Breadcrumbs()
{
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    return (<div className="crumbs">
        <div className="d-flex align-items-center container flex-wrap">
            <Link to={'/'} >Главная</Link>
            {state.breadcrumbs.map((item, index) => <Fragment key={index}><span>/</span>{item.url ? <Link to={item.url} >{item.name}</Link> : item.name}</Fragment>)}
        </div>
    </div>)
}